import React from 'react';
import PropTypes from 'prop-types';

const AiQuery = ({
	query,
}) => (
	<div className="flex-row justify-flex-end">
		<div className="ignite-ai__query-container">
			{query}
		</div>
	</div>
);

export default AiQuery;

AiQuery.propTypes = {
	query: PropTypes.string.isRequired,
};
